import type { Vendor } from '@cruz-com/lookup'
import _ from 'lodash'
import { memo } from 'react'
import { JsonLd } from 'react-schemaorg'
import type Schema from 'schema-dts'
import slugify from 'slugify'
import { webBaseUrl } from '@/settings'

export const DealerLocationSchema = memo(({ dealerLocation }: { dealerLocation: Vendor.Location }) => {
  try {
    if (!dealerLocation || _.isEmpty(dealerLocation)) {
      return null
    }

    const { _id, name, address1, city, state_abbr, zip_code, phone, place, nearby_cities } = dealerLocation || {}

    if (!name) {
      return null
    }

    function getAddress() {
      if (place?.full_address) {
        const x = place.full_address.split(', ')
        const address = _.dropRight(x, 2).join(', ')
        return address
      }
      return address1
    }

    const slugNmae = slugify(name, { lower: true })
    const slugLocation = slugify([city, state_abbr, zip_code].join(' '), { lower: true })

    const schema: Schema.WithContext<Schema.AutoDealer> = {
      '@context': 'https://schema.org',
      '@type': 'AutoDealer',
      name: place?.display_name || name || '',
      address: {
        '@type': 'PostalAddress',
        streetAddress: getAddress(),
        addressLocality: city,
        addressRegion: state_abbr,
        postalCode: zip_code,
        addressCountry: 'US',
      },
      telephone: phone,
      areaServed: nearby_cities || city,
      currenciesAccepted: 'USD',
      url: `${webBaseUrl}/vehicles/dealer/${slugNmae}/${slugLocation}/${_id}`,
    }

    if (place && (place.rating || 0) > 0) {
      // Need 'review' (not 'reivew') and often an aggregateRating is preferred for businesses.
      schema.aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue: place.rating,
        reviewCount: place.rating_count || 10,
      }
    }

    return <JsonLd<Schema.AutoDealer> item={schema} />
  } catch {
    return null
  }
})
